
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/sip-swp",
      function () {
        return require("private-next-pages/calculators/sip-swp/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/sip-swp"])
      });
    }
  